import { Provider } from 'root/src/shared/@types/providers';
import { useSignInWithProvider } from 'root/src/client/web/auth/hooks/useSignInWithProvider';
import { useUserData } from 'root/src/client/v2/userData/hooks/useUserData';
import { GoogleIcon, TwitchIcon, TikTokIcon } from 'root/src/client/v2/common/components/icons/providerIcons';
import { DiscordIcon } from 'root/src/client/v2/common/components/icons/DiscordIcon';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Partial on purpose, but keep every provider the auth form offers in here: a missing
// entry renders a label with no icon rather than failing to compile.
const providerIconMap = {
    [Provider.Twitch]: TwitchIcon,
    [Provider.Google]: GoogleIcon,
    [Provider.TikTok]: TikTokIcon,
    [Provider.Discord]: DiscordIcon,
};
// The single redesign "Sign in with {provider}" button, used by every auth modal so they match.
export const RedesignSignInWithProviderButton = (props) => {
    const { provider, providerLabel, onSignIn, isLoading } = useSignInWithProvider({
        provider: props.provider,
        isLinking: props.isLinking,
        popup: props.popup,
        popupOptions: props.popup ? props.popupOptions : undefined,
        scopeSet: props.scopeSet,
    });
    const Icon = providerIconMap[provider];
    return (<Button variant="outline" loading={isLoading} disabled={props.disabled} onClick={onSignIn} className={cn('w-full gap-2 rounded-lg text-sm font-semibold', props.className)}>
			{Icon && <Icon className="h-4 w-4"/>}
			Sign in with {providerLabel}
		</Button>);
};
// All three provider buttons (Connect Channels), disabling the ones already connected.
export const RedesignSignInWithProviderButtons = (props) => {
    const { userData, isLoading } = useUserData();
    const creatorData = userData === null || userData === void 0 ? void 0 : userData.creatorData;
    return (<div className={cn('flex w-full flex-col gap-3', props.className)}>
			<RedesignSignInWithProviderButton provider={Provider.Twitch} isLinking={props.isLinking} disabled={Boolean(creatorData === null || creatorData === void 0 ? void 0 : creatorData.twitchData) || isLoading} popup={props.popup} popupOptions={props.popupOptions}/>
			<RedesignSignInWithProviderButton provider={Provider.Google} isLinking={props.isLinking} disabled={Boolean(creatorData === null || creatorData === void 0 ? void 0 : creatorData.youtubeData) || isLoading} popup={props.popup} popupOptions={props.popupOptions}/>
			<RedesignSignInWithProviderButton provider={Provider.TikTok} isLinking={props.isLinking} disabled={Boolean(creatorData === null || creatorData === void 0 ? void 0 : creatorData.tiktokData) || isLoading} popup={props.popup} popupOptions={props.popupOptions}/>
		</div>);
};
